$(function() {
  var hideIvt = setInterval(function() {
    if ($('.scroll-to-top').length > 0) {
      $('.scroll-to-top').remove();
      clearInterval(hideIvt);
    }
  }, 1000);
  $('.add-to-cart-button-alt').on('click', function() {
    $('.add-to-cart-button').trigger('click');
  });

  var el, classname;

  
  el = $('.recyko-21-product-spec-div .product-box');
  if (el.length > 0) {
    resizeSpecBox();
    $(window).on('resize', resizeSpecBox);
    $(window).on('load', resizeSpecBox);
    function resizeSpecBox() {
      var flag = true;
      var i = 1;

      do {
        el = $('.recyko-21-product-spec-div .product-box');
        var divs = $('> div:nth-child('+i+')', el);
        
        if (divs.length == 0) flag = false;

        divs.css({height: 'auto'});

        $(window).width() >= 768
          ? resizeSpecBoxPc(i)
          : resizeSpecBoxMb(i);

        i++;
      } while(flag);
    }
    function resizeSpecBoxPc(i) {
      el = $('.recyko-21-product-spec-div .product-box');
      divs = $('> div:nth-child('+i+')', el);

      var H = 0;
      divs.each(function() {
        var h = $(this).outerHeight();
        if (h > H) H = h;
      });

      divs.css({height: H});
    }
    function resizeSpecBoxMb(i) {
      els = $('.recyko-21-product-spec-div > .row > div');

      els.each(function() {
        divs = $('.product-box > div:nth-child('+i+')', this);

        var H = 0;
        divs.each(function() {
          var h = $(this).outerHeight();
          if (h > H) H = h;
        });

        divs.css({height: H});
      });
    }
  }

  
  if ('loading' in HTMLImageElement.prototype) {
    var lazyImages = document.querySelectorAll('.recyko-21 img');
      
    for (var img of lazyImages) {
      if (!img.complete) {
        img.parentNode.classList.add('lazyImageWaiting');
        img.addEventListener('load', lazyImageLoad, false);
        img.addEventListener('error', lazyImageError, false);
      }
    }
    
    function lazyImageLoad(e) {
      e.currentTarget.parentNode.classList.remove('lazyImageWaiting');
      e.currentTarget.parentNode.classList.add('lazyImageLoaded');
      if (typeof resizeSpecBox !== 'undefined') resizeSpecBox();
    }
    
    function lazyImageError(e) {
      var parent = e.currentTarget.parentNode;
      parent.classList.remove('lazyImageWaiting');
      parent.classList.add('lazyImageError');
      setTimeout(function() {
        parent.classList.add('lazyImageErrorShow');
      }, 60);
    }
    
  } // if 'loading' supported

  
  var header = $('.recyko-21-header');
  
  $('.menu a', header).on('click', function(e) {
    var el = $(this).data('el')
    if (typeof el !== 'undefined') {
      if ($(el)[0].nodeName == 'A') {
        window.open($(el).attr('href'), $(el).attr('target'));
      }

      var t = $(el).offset().top,
        scroll_top = $(document).scrollTop();

      var buffer = $('.recyko-21-header').outerHeight();
      if (scroll_top > t) {
        buffer += $('#site-header').outerHeight();
      } else {
      }
      buffer -= 2;

      $('html, body').animate({
        scrollTop: t - buffer
      }, 300);

      e.preventDefault();
    } else {
      return true;
    }
  });

  
  $('.charge-10-buy').on('click', function() {
    $('.shopify-payment-button__button').trigger('click');
  });

  $('.charge-10-add').on('click', function() {
    $('.add-to-cart-button').trigger('click');
  });
  
  if ($('.coming-soon-button').length == 1 || $('.sold-out-button').length == 1) {
    $('.charge-10-buy').hide();
    $('.charge-10-add').hide();
  }
});